// eslint-disable-next-line
import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

class ServiceProvider extends Component {

  static propTypes = {
    services: PropTypes.object.isRequired
  }
  // you must specify what you’re adding to the context
  static childContextTypes = {
    services: PropTypes.object.isRequired
  }

  getChildContext () {
    const { services } = this.props;
    return { services };
  }

  render () {
    // `Children.only` enables us not to add a <div /> for nothing
    return Children.only(this.props.children);
  }
}

export default ServiceProvider;


// WEBPACK FOOTER //
// ./src/providers/ServiceProvider.js